/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { ModalDropdownMenuHeader, ModalTabContent } from "@packages/ui";

import { useMediaAnalyticsProps } from "../../../../hooks/useMediaAnalyticsProps";
import { SelectGuideContent } from "./SelectGuideContent.emotion";

export const SelectGuideTabContent = () => {
  const t = useTranslations();
  const { track } = useAnalytics();
  const analyticsProps = useMediaAnalyticsProps();

  return (
    <ModalTabContent
      value={"guideSelectMenu"}
      key={"guideSelectMenu"}
      header={
        <ModalDropdownMenuHeader>
          {t("track_settings_guide")}
        </ModalDropdownMenuHeader>
      }
      onVisible={() =>
        track({
          event: HallowAnalyticsEvent.ViewedGuideOptions,
          properties: {
            ...analyticsProps,
            source: "player",
          },
        })
      }
    >
      <SelectGuideContent />
    </ModalTabContent>
  );
};
